const sizeOptions = [
  { id: '1', min: 1, max: 20, text: '1-20' },
  { id: '2', min: 21, max: 50, text: '21-50' },
  { id: '3', min: 51, max: 150, text: '51-150' },
  { id: '4', min: 151, max: 300, text: '151-300' },
  { id: '5', min: 301, max: 1000, text: '301-1000' },
  { id: '6', min: 1001, max: 5000, text: '1001-5000' },
  { id: '7', min: 5001, text: '5000+' },
];

module.exports = {
  sizeOptions,
};
